import type { PlaceholderSubcategoryWriteRequest } from '@/api/generated/schemas';
import type { SubcategoryFormValues } from './subcategoryFormSchema';

function emptyToNull(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/**
 * Mapuje hodnoty formuláře na API tělo zápisu subkategorie. Create i Update mají shodný tvar těla,
 * takže stačí jeden builder.
 */
export function toSubcategoryRequestBody(
  values: SubcategoryFormValues
): PlaceholderSubcategoryWriteRequest {
  return {
    name: values.name.trim(),
    code: emptyToNull(values.code),
    status: values.status,
    type: values.type,
  } satisfies PlaceholderSubcategoryWriteRequest;
}
